// A single SO with 5 items (matches your SO schema)
const dummySalesOrder = {
    _id: "SO-DUMMY-0001",
    soDetails: {
        soNumber: "SO9001",
        status: "New",
        orderType: "SO",
        orderDate: "2025-09-29T09:30:00.000Z",
        externalSoNumber: null,
        owner: "Acme Retail",
        expectedReceiptDate: "2025-10-02T00:00:00.000Z",
        totalWeight: 10,
        totalVolume: 5,
        totalOrderedQuantity: 50,
        openQuantity: 50,
        source: "INTERNAL",
    },
    sourceDetail: {
        locationName: "Main DC",
        addressLine1: "Warehouse 21",
        city: "Marina",
        state: "Dubai",
        country: "UAE",
    },
    destination: {
        locationName: "Acme Store Downtown",
        addressLine1: "Plot 5",
        city: "Downtown",
        state: "Dubai",
        country: "UAE",
    },
    lineItems: [
        {
            _id: "LI-1",
            detail: {
                lineNumber: "00001",
                salesOrder: "SO9001",
                skuId: "HRU001",
                description: "Turin Curved Back Upholstered Dining Chair - Beige",
                pack: "STD",
                orderedQty: 3,
                openQty: 10,
                dispatchQty: 0,
                uom: "EA",
                qcRequired: false,
            },
        },
        {
            _id: "LI-2",
            detail: {
                lineNumber: "00002",
                salesOrder: "SO9001",
                skuId: "HRU004",
                description: "Ethan 8-Seater Wooden Rectangular Dining Table - Brown",
                pack: "STD",
                orderedQty: 2,
                openQty: 12,
                dispatchQty: 0,
                uom: "EA",
                qcRequired: false,
            },
        },
        {
            _id: "LI-3",
            detail: {
                lineNumber: "00003",
                salesOrder: "SO9001",
                skuId: "HRU005",
                description: "Aasma Upholstered Dining Chair Backrest",
                pack: "STD",
                orderedQty: 4,
                openQty: 8,
                dispatchQty: 0,
                uom: "EA",
                qcRequired: false,
            },
        },
        {
            _id: "LI-4",
            detail: {
                lineNumber: "00004",
                salesOrder: "SO9001",
                skuId: "HRU007",
                description: "Chrys 8-Seater Wooden Top Dining Table",
                pack: "STD",
                orderedQty: 1,
                openQty: 15,
                dispatchQty: 0,
                uom: "EA",
                qcRequired: false,
            },
        },
        {
            _id: "LI-5",
            detail: {
                lineNumber: "00005",
                salesOrder: "SO9001",
                skuId: "HRU010",
                description: "Barbara 6-Seater Dining Table",
                pack: "STD",
                orderedQty: 5,
                openQty: 5,
                dispatchQty: 0,
                uom: "EA",
                qcRequired: false,
            },
        },
    ],
};

export default dummySalesOrder;
